/* (c) 2020-2023, Nextwave Logic, Inc. All Rights Reserved */

import React, { useState, useEffect, useContext } from 'react';
import { FormGroup, Input, Badge, Label, Button, Col, Progress } from 'reactstrap';
import Alert from 'react-s-alert';
import Joyride, { STATUS } from 'react-joyride';

// context imports
import { ThemeContext } from '../../../contexts/ThemeContext';
import { AuthContext } from '../../../contexts/AuthContext';

// service imports
import DemoService from '../../../services/DemoService';
import GeneralService from '../../../services/GeneralService';

// local imports
import ErrorBoundary from '../../general/ErrorBoundary';
import ClientNavbar from './ClientNavbar';
import Message from '../../general/Message';
import './Form.css';

const Form = props => {

    // contexts
    const { theme, colors } = useContext(ThemeContext);

    // useState
    const [user, setUser] = useState({ firstName: "", lastName: "", email: "", selectedRole: '', roles: [], profileImage: "", demoTakenFor: [] });
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [showForms, setShowForms] = useState({ status: false, forms: [] });
    const [formType, setFormType] = useState("");
    const [formName, setFormName] = useState("");
    const [formQuestions, setFormQuestions] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [showPrevBtn, setShowPrevBtn] = useState(false);
    const [showNextBtn, setShowNextBtn] = useState(false);
    const [showSubmitBtn, setShowSubmitBtn] = useState(false);
    const [message, setMessage] = useState();
    const [tutorial, setTutorial] = useState({
        status: false,
        steps: [
            {
                content: <h2>Here you will get to view and fill up forms given by your selected counsellor.</h2>,
                placement: 'center',
                target: '#clientFormDiv'
            }
        ]
    });
    let helpers = null;

    // useEffect(() => console.log('tutorial', tutorial, 'showForms', showForms), [tutorial, showForms])

    useEffect(() => {
        DemoService.getUserData().then(data => {
            if (data.isAuthenticated) {
                if (data.user.roles[0] === "DemoClient") {
                    setUser(data.user);
                    // console.log('user', data)
                    if (!data.user.demoTakenFor.includes("ClientForm")) {
                        setTutorial({ ...tutorial, status: true });
                    }
                } else {
                    // props.history.replace('PagePath');
                }
            } else {
                props.history.replace('/demo/signin');
            }
        })
    }, []);

    useEffect(() => {
        setFormName("");
        setFormQuestions([]);
        const path = window.location.pathname;
        if (path === "/demo/client/form") {
            showFilledForms();
        } else if (path === "/demo/client/form/clientForm") {
            openForm("ClientForm");
        } else if (path === "/demo/client/form/teenForm") {
            openForm("TeenChecklist");
        } else if (path === "/demo/client/form/adultForm") {
            openForm("AdultChecklist");
        } else if (path === "/demo/client/form/coupleForm") {
            openForm("CoupleChecklist");
        }
    }, [window.location.pathname]);

    useEffect(() => {
        if (currentIndex === 0) {
            setShowPrevBtn(false);
        } else {
            setShowPrevBtn(true);
        }
        if (formQuestions.length === currentIndex + 1) {
            setShowNextBtn(false);
            setShowSubmitBtn(true);
        } else {
            setShowNextBtn(true);
            setShowSubmitBtn(false);
        }
    }, [currentIndex, formQuestions.length]);

    const showFilledForms = () => {
        try {
            setIsLoading(true);
            setShowForms({ status: true, forms: [] });
            // ClientService.getFormList().then(data => {
            //     setShowForms({ status: true, forms: data.forms });
            setIsLoading(false);
            // })
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client Form showFilledForms', 'Error in try catch block', err.stack);
        }
    }

    const handleSelectForm = (type) => {
        if (type === "ClientForm") {
            props.history.push('/client/form/clientForm')
        } else if (type === "TeenChecklist") {
            props.history.push('/client/form/teenForm')
        } else if (type === "AdultChecklist") {
            props.history.push('/client/form/adultForm')
        } else if (type === "CoupleChecklist") {
            props.history.push('/client/form/coupleForm')
        }
    }

    const openForm = (type) => {
        // setFormType(type);
        // ClientService.getForm(type).then(form => {
        //     try {
        //         if (form.isSubmitted) {
        //             setShowForms({ ...showForms, status: false });
        //             setFormName(form.data.form);
        //             setFormQuestions(form.data.response);
        //             setIsSubmitted(true);
        //         } else {
        //             setIsSubmitted(false);
        //             setFormName(form.form);
        //             setFormQuestions(form.questions);
        //         }
        //     } catch (err) {
        //         Alert.error("Some error occured, please try again later or report support team.", {
        //             position: 'top-right',
        //             effect: 'slide'
        //         });
        //         GeneralService.logError('at Client Form openForm', 'Error in try catch block', err.stack);
        //     }
        // })
    }

    const prevQuestion = () => {
        setCurrentIndex(currentIndex - 1);
    }

    const nextQuestion = () => {
        if (formQuestions[currentIndex].userResponse) {
            setCurrentIndex(currentIndex + 1);
        } else {
            setMessage({ msgError: true, msgBody: "Please select one option" });
        }
    }

    const handleChange = (type, index) => {
        try {
            setMessage();
            if (!isSubmitted) {
                if (type === "radio") {
                    const tempArray = [...formQuestions];
                    tempArray[currentIndex].userResponse = [formQuestions[currentIndex].answers[index]];
                    setFormQuestions(tempArray);
                } else {
                    const tempArray = [...formQuestions];
                    const responseArray = tempArray[currentIndex].userResponse ? tempArray[currentIndex].userResponse : [];
                    const foundIndex = responseArray.indexOf(formQuestions[currentIndex].answers[index]);
                    if (foundIndex > -1) {
                        responseArray.splice(foundIndex, 1);
                    } else {
                        responseArray.push(formQuestions[currentIndex].answers[index]);
                    }
                    tempArray[currentIndex].userResponse = responseArray;
                    setFormQuestions(tempArray);
                }
            }
        } catch (err) {
            Alert.error("Some error occured, please try again later or report support team.", {
                position: 'top-right',
                effect: 'slide'
            });
            GeneralService.logError('at Client Form handleChange', 'Error in try catch block', err.stack);
        }
    }

    const handleSubmit = e => {
        // try {
        //     if (!isLoading) {
        //         setIsLoading(true);
        //         ClientService.submitForm(formType, formQuestions).then(data => {
        //             Alert.info(data.message.msgBody, {
        //                 position: 'top-right',
        //                 effect: 'slide'
        //             });
        //             setIsLoading(false);
        //             props.history.push('/client/dashboard');
        //         }).catch(error => {
        //             Alert.error(error.message.msgBody, {
        //                 position: 'top-right',
        //                 effect: 'slide'
        //             });
        //             setIsLoading(false);
        //         });
        //     }
        // } catch (err) {
        //     Alert.error("Some error occured, please try again later or report support team.", {
        //         position: 'top-right',
        //         effect: 'slide'
        //     });
        //     setIsLoading(false);
        //     GeneralService.logError('at Client Form handleSubmit', 'Error in try catch block', err.stack);
        // }
    }

    const handleJoyrideCallback = (data) => {
        const { status, type } = data;
        const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

        if (finishedStatuses.includes(status)) {
            if (!user.demoTakenFor.includes("ClientForm")) {
                DemoService.markVisited("ClientForm");
                setUser({ ...user, demoTakenFor: [...user.demoTakenFor, "ClientForm"] });
            }
            setTutorial({ ...tutorial, status: false });
        }
    };

    const getHelpers = (paramHelpers) => {
        helpers = paramHelpers;
    };

    return (
        <div id="clientFormDiv" className="formDiv">
            <ErrorBoundary errorAt="At Client Form Joyride">
                <Joyride
                    callback={handleJoyrideCallback}
                    continuous={true}
                    getHelpers={getHelpers}
                    run={tutorial.status}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={false}
                    steps={tutorial.steps}
                    locale={{ last: 'Finish' }}
                    styles={{
                        options: {
                            primaryColor: "rgb(56, 78, 115)",
                            zIndex: 10000,
                        },
                    }}
                />
            </ErrorBoundary>
            <ErrorBoundary errorAt="At Client Form ClientNavbar">
                <ClientNavbar history={props.history} showTutorial={() => setTutorial({ ...tutorial, status: true })} />
            </ErrorBoundary>
            <div className="p-3 col-md-6 mt-5 offset-md-3" style={theme.form}>
                <ErrorBoundary errorAt="At Client Form Message">
                    {message ? <Message message={message} /> : null}
                </ErrorBoundary>
                {
                    isLoading ?
                        <h4 className="text-center">Loading...</h4>
                        :
                        showForms.status ?
                            showForms.forms.length === 0 ?
                                <h4 id="not-submitted-forms" className="text-center">You have not submitted any forms yet</h4>
                                :
                                showForms.forms.map((item, index) => (
                                    <div key={index} className="p-3 my-3" style={theme.card}>
                                        <div className="d-flex" style={{ cursor: "pointer" }} onClick={() => handleSelectForm(item.form)}>
                                            <Badge style={{ backgroundColor: colors.primary, marginRight: "15px", height: "fit-content" }}>{index + 1}</Badge>
                                            <span style={theme.headingBold}>{item.form}</span>
                                        </div>
                                    </div>
                                ))
                            :
                            formQuestions.length > 0 ?
                                <div>
                                    {isSubmitted ? <h4 id="already-submitted" className="text-center">You have already submitted this form.</h4> : null}
                                    <div className="p-3 mt-3 questionCard">
                                        <div className="d-flex">
                                            <Badge style={{ backgroundColor: colors.primary, marginRight: "15px", height: "fit-content" }}>{currentIndex + 1}</Badge>
                                            <span style={theme.headingBold}>{formQuestions[currentIndex].question}</span>
                                        </div>
                                        <hr />
                                        <ErrorBoundary errorAt="At Client Form FormAnswers">
                                            {
                                                formQuestions[currentIndex].answers.map((item, index) => (
                                                    formQuestions[currentIndex].type === "radio" ?
                                                        <FormGroup key={index} tag="fieldset" row className="answerFormGroup">
                                                            <Col sm={10}>
                                                                <FormGroup check>
                                                                    <Label check className="answerLabel" style={{ cursor: "pointer" }}>
                                                                        <Input type="radio" name={`answer${currentIndex}`} style={{ cursor: "pointer" }}
                                                                            checked={formQuestions[currentIndex].userResponse ? formQuestions[currentIndex].userResponse[0] === item : false}
                                                                            onChange={(e) => handleChange(e.target.type, index)} />
                                                                        <span className="ml-2 radioText">{item}</span>
                                                                    </Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </FormGroup>
                                                        :
                                                        <FormGroup key={index} tag="fieldset" row className="answerFormGroup">
                                                            <Col sm={10}>
                                                                <FormGroup check>
                                                                    <Label check className="answerLabel" style={{ cursor: "pointer" }}>
                                                                        <Input type="checkbox" name={`answer${currentIndex}`} style={{ cursor: "pointer" }}
                                                                            checked={formQuestions[currentIndex].userResponse ? formQuestions[currentIndex].userResponse.includes(item) : false}
                                                                            onChange={(e) => handleChange(e.target.type, index)} />
                                                                        <span className="ml-2 radioText">{item}</span>
                                                                    </Label>
                                                                </FormGroup>
                                                            </Col>
                                                        </FormGroup>
                                                ))
                                            }
                                        </ErrorBoundary>
                                        <div className="d-flex mt-3">
                                            {showPrevBtn ? <Button id="previousBtn" onClick={() => prevQuestion()}>Previous</Button> : null}
                                            {showNextBtn ? <Button id="nextBtn" className="ml-auto" style={{ backgroundColor: colors.primary }} onClick={() => nextQuestion()}>Next</Button> : null}
                                            {isSubmitted ? null : showSubmitBtn ? <Button id="submitBtn" className="ml-auto" style={{ backgroundColor: colors.primary }} onClick={() => handleSubmit()}>{isLoading ? <span className="spinner-border spinner-border-sm mr-1"></span> : null}Submit</Button> : null}
                                        </div>
                                    </div>
                                </div>
                                : null
                }
                <ErrorBoundary errorAt="At Client Form ProgressBar">
                    {formQuestions.length > 0 ? <Progress value={(((currentIndex + 1) * 100) / formQuestions.length)} /> : null}
                </ErrorBoundary>
            </div>
        </div>
    )
}

export default Form;